export default __webpack_public_path__ + "static/logo_loader-0ab37bf3d2a571dd68e5c56b1ed197da.png";